import { render, staticRenderFns } from "./GroupMembersEdit.vue?vue&type=template&id=7827a2cc"
import script from "./GroupMembersEdit.vue?vue&type=script&lang=js"
export * from "./GroupMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./GroupMembersEdit.vue?vue&type=style&index=0&id=7827a2cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports